var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-material-card',_vm._g(_vm._b({staticClass:"v-card--material-stats",scopedSlots:_vm._u([{key:"actions",fn:function(){return [_vm._t("actions")]},proxy:true}],null,true)},'app-material-card',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.value)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }